import React, {useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import {Link} from 'react-router-dom';
import RecommendResource from './RecommendResource';


// Listing
const ListingContainer = styled.div`
    display: flex;
    flex-direction: column; /* Stack children vertically */
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin-top: 0px;
`;

const ListingWrapper = styled.div`
    position: relative;
    display: flex;
    width: 1280px;
    margin-top: 43px;
    gap: 10px;
`;

const ButtonWrapper = styled.div`
    position: relative;
    display: flex;

    justify-content: flex-start;
    align-items: flex-start;
    width: 200px;
    margin-top: 17px;
`;

const ListingWrap = styled.div`
    position: relative;
    display: flex;
    width: 1020px;
`;

// Sidebar
const SidebarContainer = styled.div`
    position: relative;
    height: 820px; /* Extend sidebar to full height */
    display: flex;
    flex-direction: column; /* Stack children vertically */
    padding-top: 33px;
`;


const SidebarWrapper = styled.div`
    width: 260px;
    height: 820px; /* Extend sidebar to full height */
    background-color: #54BAB2; /* Light teal background */
    color: #fefefe; /* White text color */
    margin: 0px; /* Add some spacing around */
    padding: 30px; /* Inner padding for content */
`;

const SidebarTitle = styled.h1`
    font-family: 'Nunito Sans', sans-serif;
    font-size: 24px;
    color: #333; /* Darker text color for contrast */
    margin-bottom: 15px;
    color: #fefefe; /* White text color */
`;


// Filters
const FilterOptions = styled.div`
    position: relative;
    display: flex;
    flex-direction: column; /* Stack children vertically */
    padding-left: 15px;
    padding-top: 9px;
    padding-bottom: 50px;

`;

const CustomCheckbox = ({option, handleCheckboxChange, activeFilters}) => {
    return (
        <label style={{display: "flex", alignItems: "center", cursor: "pointer"}}>
            <input
                type="checkbox"
                onChange={() => handleCheckboxChange(option)}
                checked={activeFilters.includes(option)}
                style={{
                    appearance: "none", // Removes default checkbox styles
                    WebkitAppearance: "none",
                    MozAppearance: "none",
                    width: "15px",
                    height: "15px",
                    backgroundColor: "white",
                    cursor: "pointer",
                    position: "relative",
                }}
            />
            {/* Checkmark overlay */}
            <span
                style={{
                    position: "absolute",

                    display: activeFilters.includes(option) ? "block" : "none",
                    color: "#144845",
                    fontSize: "25px",
                    textAlign: "center",
                    lineHeight: "20px", // Matches the height of the box
                    borderRadius: "4px", // Matches the checkbox style
                    pointerEvents: "none", // Avoid interfering with input interaction
                }}
            >
                ✓
            </span>
            <span style={{marginLeft: "8px"}}>{option}</span>
        </label>
    );
};


const FilterLabel = styled.label`
    display: block;
    margin: 3px 0;
    color: #144845;
`;

// Call To Action
const SubHeading = styled.h1`
    font-family: 'Nunito Sans', sans-serif;
    font-size: 35px;
    color: #707070;
    text-align: left;
    letter-spacing: 0px;
    line-height: 47px;
    margin: 0 0 20px 0;
`;

const CallToActionWrapper = styled.div`
    display: flex;
    width: 270px;
    position: relative;
    align-items: flex-start;
    flex-direction: column;

    padding-top: 51px;
    padding-left: 40px;
    color: #333;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
`;



const ListItem = styled.li`
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    color: #FEFEFE;
    list-style: none;
    text-transform: uppercase;
    padding: 7px;
cursor: pointer; /* Ensures it looks clickable */
    user-select: none; /* Prevents text selection when clicking */
    &:hover {
        color: #144845; /* Optional hover effect */
    }

    &:active {
        color: #FF4500; /* Optional active state effect */
    }
`;


// Listing Item
const ItemWrapper = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding-top: 8px;
    gap: 16px;
`;

const Item = styled.div`
    position: relative;
    margin: 0px;
    width: 231px;
    height: 200px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0px;
`;

const LoadMoreWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 850px;
    margin: 0px;
    width: 100%;
`;

const ItemImage = styled.img`
    width: 231px;
    height: auto;
`;

const ItemTextOverlay = styled(Link)`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 194px;
    height: 63px;
    top: -44px;
    background: #ffffff;
    box-shadow: 0px 3px 6px #00000010;
    padding: 8px;
    text-align: center;
    gap: 2px;

    &:hover {
        transform: scale(1.1);
    }
`;

const CategoryTitle = styled.h2`
    font-family: 'Nunito Sans', sans-serif;
    font-size: 18px;
    font-weight: 500;
    color: #707070;
    margin: 0px 0;
`;

const ItemLocation = styled.h2`
    font-family: 'EB Garamond', serif;
    font-size: 8px;
    color: #707070;
    margin: 0px;
    text-transform: uppercase;
`;

const ItemTitle = styled.h2`
    font-family: 'Oswald', sans-serif;
    font-size: 12px;
    font-weight: 500;
    color: #e85f45;
    margin: 0px 0;
    text-transform: uppercase;
`;

const ItemSubtitle = styled.p`
    font-family: 'Nunito Sans', sans-serif;
    font-size: 9px;
    color: #82837F;
    text-align: center;
`;

const CategoryWrapper = styled.div`
    position: relative;
    display: flex;
    width: 100%;
    margin-top: 20px;
`;
const Categories = styled.div`

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: column;
    width: 100%;
    height: 300px;
    gap: 90px;
`;

// Colors
const borderColor = '#54BAB2';
const borderHoverColor = 'rgba(246,155,66,0.62)';
const textColor = '#54BAB2';
const textHoverColor = 'rgba(246,155,66,0.62)';

// Style the button with the winking animation
const WinkingButton = styled(Link)`
    position: relative;
    top: 0px;
    left: 0px;
    width: 131px;
    height: 42px;
    border: 2px solid ${borderColor};
    border-radius: 0px;
    cursor: pointer;
    font-family: 'Oswald', sans-serif;
    font-weight: normal;
    font-size: 24px;
    color: ${textColor};
    text-align: center;
    line-height: 36px; /* Adjust line height to vertically center the text */
    transition: transform 0.2s, background-color 0.2s;

    &:hover {
        transform: scale(1.1);
        border: 2px solid ${borderHoverColor};
        color: ${textHoverColor};
    }
`;

// Colors
const loadMoreBorderColor = '#707070';
const loadMoreBorderHoverColor = 'rgba(246,155,66,0.62)';
const loadMoreTextColor = '#707070';
const loadMoreTextHoverColor = 'rgba(246,155,66,0.62)';

// Style the button with the winking animation
const LoadMoreWinkingButton = styled(Link)`
    position: relative;
    top: 0px;
    left: 0px;
    width: 131px;
    height: 42px;
    border: 2px solid ${loadMoreBorderColor};
    border-radius: 0px;
    cursor: pointer;
    font-family: 'Oswald', sans-serif;
    font-weight: normal;
    font-size: 24px;
    color: ${loadMoreTextColor};
    text-align: center;
    line-height: 36px; /* Adjust line height to vertically center the text */
    transition: transform 0.2s, background-color 0.2s;

    &:hover {
        transform: scale(1.1);
        border: 2px solid ${loadMoreBorderHoverColor};
        color: ${loadMoreTextHoverColor};
    }
`;



const handleItemClick = (item) => {
    console.log(`${item} clicked`);
};

const Filters = ({activeFilters, setActiveFilters}) => {
    const handleCheckboxChange = (tag) => {
        setActiveFilters((prevFilters) =>
            prevFilters.includes(tag)
                ? prevFilters.filter((filter) => filter !== tag)
                : [...prevFilters, tag]
        );
    };

    const filterOptions = [
        'POC owned',
        'Mama owned',
        'LGBTQ owned',
        'Women-Led',
    ];

    return (
        <SidebarContainer>
            <SidebarWrapper>
                <SidebarTitle>FILTERS</SidebarTitle>
                <FilterOptions>
                    {filterOptions.map((option) => (
                        <FilterLabel key={option}>
                            <CustomCheckbox
                                key={option}
                                option={option}
                                handleCheckboxChange={handleCheckboxChange}
                                activeFilters={activeFilters}
                            />

                        </FilterLabel>
                    ))}
                </FilterOptions>
                <ul>
                    <ListItem onClick={() => handleItemClick('Apparel & Shoes')}>Apparel & Shoes</ListItem>
                    <ListItem onClick={() => handleItemClick('Art & Design')}>Art & Design</ListItem>
                    <ListItem onClick={() => handleItemClick('Beauty & Spa')}>Beauty & Spa</ListItem>
                    <ListItem onClick={() => handleItemClick('Childcare')}>Childcare</ListItem>
                    <ListItem onClick={() => handleItemClick('Education')}>Education</ListItem>
                    <ListItem onClick={() => handleItemClick('Food')}>Food</ListItem>
                    <ListItem onClick={() => handleItemClick('Fitness')}>Fitness</ListItem>
                    <ListItem onClick={() => handleItemClick('Home Decor')}>Home Decor</ListItem>
                    <ListItem onClick={() => handleItemClick('Entertaining')}>Entertaining</ListItem>
                    <ListItem onClick={() => handleItemClick('Jewelry')}>Jewelry</ListItem>
                    <ListItem onClick={() => handleItemClick('Life Coaching')}>Life Coaching</ListItem>
                    <ListItem onClick={() => handleItemClick('Pregnancy & Birth')}>Pregnancy & Birth</ListItem>
                    <ListItem onClick={() => handleItemClick('Menopause')}>Menopause</ListItem>
                    <ListItem onClick={() => handleItemClick('Healthcare')}>Healthcare</ListItem>
                </ul>
            </SidebarWrapper>
            <CallToActionWrapper>
                <SubHeading>Are you a business?<br/>Get M-Listed!</SubHeading>
                <ButtonWrapper>
                    <WinkingButton to="/contact">CONTACT</WinkingButton>
                </ButtonWrapper>
            </CallToActionWrapper>
        </SidebarContainer>
    );
};

const handleRecommendationSubmit = () => {
    alert('Recommendation submitted!');
};

Filters.propTypes = {
    activeFilters: PropTypes.array.isRequired,
    setActiveFilters: PropTypes.func.isRequired,
};

const CategorySection = ({title, listings}) => (
    <div className="category-section">
        <CategoryTitle>{title}</CategoryTitle>
        <ItemWrapper>
            {listings.map((listing, index) => (
                <Item key={index}>
                    <ItemImage src={listing.image} alt={listing.title}/>
                    <ItemTextOverlay to={`/feature/${listing.id}`}>
                        <ItemLocation>{listing.location.toUpperCase()}</ItemLocation>
                        <ItemTitle>{listing.title}</ItemTitle>
                        <ItemSubtitle>{listing.description}</ItemSubtitle>
                    </ItemTextOverlay>
                </Item>
            ))}
        </ItemWrapper>
    </div>
);


const CategorySectionMod = ({title, listings}) => {
    // Ensure we only process a maximum of 2 items
    const displayedListings = listings.slice(0, 2); // First 2 items
    const excludedCount = listings.length > 2 ? listings.length - 2 : 0; // Count of excluded items

    return (
        <div className="category-section">
            <CategoryTitle>{title}</CategoryTitle>
            <ItemWrapper>
                {/* Display only the first 2 items */}
                {displayedListings.map((listing, index) => (
                    <Item key={index}>
                        <ItemImage src={listing.image} alt={listing.title}/>
                        <ItemTextOverlay to={`/feature/${listing.id}`}>
                            <ItemLocation>{listing.location.toUpperCase()}</ItemLocation>
                            <ItemTitle>{listing.title}</ItemTitle>
                            <ItemSubtitle>{listing.description}</ItemSubtitle>
                        </ItemTextOverlay>
                    </Item>
                ))}

                {/* Display a div for excluded items */}
                {excludedCount > 0 && (
                    <RecommendResource onSubmit={handleRecommendationSubmit} />
                )}
            </ItemWrapper>
        </div>
    );
};

CategorySection.propTypes = {
    title: PropTypes.string.isRequired,
    listings: PropTypes.array.isRequired,
};


const ListingDirectory = () => {
    const [activeFilters, setActiveFilters] = useState([]);

    const featuredServices = [
        {
            id: 1,
            image: '/static/img/screenshot-2024-06-06-at-11-00-33-am-1.png',
            location: 'Sonoma',
            title: 'Maya Doula',
            description: 'Pre and post-natal support',
            tags: ['POC owned', 'Women-Led']
        },
        {
            id: 2,
            image: '/static/img/screenshot-2024-06-06-at-11-03-23-am-1.png',
            location: 'Marin',
            title: 'Little Sunbeams',
            description: 'After school and holiday programs',
            tags: ['Mama owned', 'Women-Led']
        },
        {
            id: 3,
            image: '/static/img/screenshot-2024-06-06-at-11-06-24-am-1.png',
            location: 'San Francisco',
            title: 'Death by Chocolate',
            description: 'Vegan delights for special order',
            tags: ['LGBTQ owned']
        },
        {
            id: 4,
            image: '/static/img/screenshot-2024-06-06-at-11-04-03-am-1.png',
            location: 'Berkeley',
            title: 'Confident Dolphins',
            description: 'Private swimming lessons',
            tags: ['POC owned', 'LGBTQ owned']
        },
    ];

    const filteredServices = activeFilters.length
        ? featuredServices.filter((service) =>
            activeFilters.every((filter) => service.tags.includes(filter))
        )
        : featuredServices;

    const coachingServices = filteredServices; // Example using same data for simplicity
    const pregnancyAndChildbirthServices = filteredServices; // Example using same data for simplicity
    const menopause = filteredServices; // Example using same data for simplicity
    const education = filteredServices; // Example using same data for simplicity

    return (
        <ListingContainer>
            <ListingWrapper>
                <Filters activeFilters={activeFilters} setActiveFilters={setActiveFilters}/>
                <ListingWrap>
                    <Categories>
                        <CategorySection title="FEATURED" listings={filteredServices}/>
                        <CategorySection title="COACHING" listings={coachingServices}/>
                        <CategorySection title="PREGNANCY & CHILDBIRTH" listings={pregnancyAndChildbirthServices}/>
                        <CategorySectionMod title="MENOPAUSE" listings={menopause}/>
                        <CategorySection title="EDUCATION" listings={education}/>
                    </Categories>
                </ListingWrap>
            </ListingWrapper>
            <LoadMoreWrapper>
                <LoadMoreWinkingButton to="/load-more">LOAD MORE</LoadMoreWinkingButton>
            </LoadMoreWrapper>
        </ListingContainer>
    );
};

export default ListingDirectory;
